import script from "./VehicleRegistrationSuggestionComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleRegistrationSuggestionComponent.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleRegistrationSuggestionComponent.vue?vue&type=style&index=0&id=0fc047a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc047a6"]])

export default __exports__